import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { faEnvelope, faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonContent,
  IonPage,
  IonRouterLink,
  IonSpinner,
} from "@ionic/react";
import { useState } from "react";
import { resetPassworEmail } from "../../lib/firebase/firebase";

import logo from "../../assets/logo1.svg";
import branding from "../../config/branding";
import { isEmbroideryTrace } from "../../config/appVariant";
import "./SignIn.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      resetPassworEmail(email);
      setSuccess(true);
      setError("");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage>
      <IonContent className="auth-background">
        <div className="auth-wrapper">
          <div className="auth-card">
            <div className="auth-logo">
              {isEmbroideryTrace ? (
                <img src={branding.logo} alt={branding.appName} style={{ height: "44px", width: "auto", objectFit: "contain" }} />
              ) : (
                <img src={logo} alt="SvgTrace" />
              )}
            </div>

            {success ? (
              <>
                <div className="email-sent-card">
                  <div className="check-icon">
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </div>
                  <h3>Check your email</h3>
                  <p>
                    We've sent instructions to reset your password to your email
                    address.
                  </p>
                </div>

                <p className="auth-prompt">
                  <IonRouterLink routerLink="/signin">
                    Back to Sign In
                  </IonRouterLink>
                </p>
              </>
            ) : (
              <>
                <div className="auth-heading">
                  <h2>Forgot password?</h2>
                  <p>
                    Enter your email and we'll send you instructions to reset
                    your password.
                  </p>
                </div>

                {error && (
                  <div className="auth-error">
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    {error}
                  </div>
                )}

                <form className="auth-form" onSubmit={handleSubmit}>
                  <div className="auth-input-group">
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                  </div>

                  <button
                    type="submit"
                    className="auth-submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <IonSpinner name="crescent" />
                    ) : (
                      "Reset Password"
                    )}
                  </button>
                </form>

                <p className="auth-prompt">
                  Remember your password?{" "}
                  <IonRouterLink routerLink="/signin">Sign In</IonRouterLink>
                </p>
              </>
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ForgotPassword;
